import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Person from '@material-ui/icons/Person';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { useEntity, EntityRefLink } from '@backstage/plugin-catalog-react';
import { EntityAboutCard } from '@backstage/plugin-catalog';

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 'bold',
    letterSpacing: 0.5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  gridItemCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)',
    marginBottom: '10px',
  },
  gridItemCardContent: {
    flex: 1,
  },
}));

export const CustomEntityAboutCard = () => {
  const { entity } = useEntity();
  const classes = useStyles();
  const createdBy = entity.spec?.createdBy as string | undefined;
  const requestedBy = entity.spec?.requestedBy as string | undefined;
  
  // Determine which field to show based on entity type
  const userField = createdBy || requestedBy;
  const fieldLabel = createdBy ? 'Created By' : 'Requested By';

  const getUserName = (userRef: string): string => {
    const lastSegment = userRef.substring(userRef.lastIndexOf('/') + 1);
    const beforeUnderscore = lastSegment.split('_')[0];
    const withSpaces = beforeUnderscore.replace(/\./g, ' ');
    return withSpaces.replace(/\b\w/g, c => c.toUpperCase());
  }

  return (
    <Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Original About Card Content */}
      <Box style={{ flex: 1 }}>
        <EntityAboutCard variant="gridItem" />
      </Box>
      
      {/* User Field Section - matches About card styling */}
      {userField && (
        <Card className={classes.gridItemCard}>
          <CardHeader
            title="Ownership Information"
          />
          <CardContent className={classes.gridItemCardContent}>
            <Typography variant="h2" className={classes.label}>
              {fieldLabel}
            </Typography>
            <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
              <Person color="secondary" style={{ fontSize: '18px' }} />
              <EntityRefLink entityRef={userField} title={getUserName(userField)} />
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};
